/**
 * Linenatura — Cart cross-sell
 * Click en .ln-cross-sell__add[data-variant-id] → /cart/add.js → refresh cart
 * Notifica al cart-drawer y secciones de cart vía PUB_SUB_EVENTS.cartUpdate.
 */
(function () {
  'use strict';

  function getSectionsForFetch() {
    // Recolecta IDs de secciones que necesitan refresh tras añadir al carrito
    var sections = [];
    document.querySelectorAll('cart-items[id], cart-drawer-items[id], cart-drawer [data-id], #main-cart-footer[data-id]').forEach(function (el) {
      var id = el.getAttribute('data-id') || el.getAttribute('id');
      if (id && sections.indexOf(id) === -1) sections.push(id);
    });
    return sections;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cross-sell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    var addedText = btn.getAttribute('data-added-text') || '✓';
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var sections = getSectionsForFetch();
    var formData = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: sections.length ? sections.join(',') : undefined,
      sections_url: window.location.pathname,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
      },
      credentials: 'same-origin',
      body: JSON.stringify(formData),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) throw new Error('add failed');

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = addedText;

        // Notify cart drawer / cart sections
        try {
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'ln-cross-sell',
              productVariantId: variantId,
              cartData: data,
            });
          }
        } catch (e) {}

        // Refrescar cart-drawer si tiene método renderContents
        try {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data);
          } else if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        } catch (e) {}

        // Refrescar página de carrito si existe
        try {
          var cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.onCartUpdate === 'function') {
            cartItems.onCartUpdate();
          } else if (cartItems && data.sections) {
            // Fallback: recargar
            window.location.reload();
          }
        } catch (e) {}

        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.textContent = originalText;
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
